const inviteActionTypes = {
  INVITE_USER: 'INVITE_USER',
  INVITE_SUCCESS: 'INVITE_SUCCESS',
  INVITE_DECLINED: 'INVITE_DECLINED',
  INVITE_FAILED: 'INVITE_FAILED',
  GET_REQUEST_BUILDING: 'GET_REQUEST_BUILDING',
  SET_REQUEST_BUILDING: 'SET_REQUEST_BUILDING',
  GET_REQUEST_LANDLORD: 'GET_REQUEST_LANDLORD',
  SET_REQUEST_LANDLORD: 'SET_REQUEST_LANDLORD',
  SET_REQUEST_USER: 'SET_REQUEST_USER',
  GET_REQUEST_USER: 'GET_REQUEST_USER',
  SEND_PROPERTY_REQUEST: 'SEND_PROPERTY_REQUEST',
  GET_REQUEST_VP: 'GET_REQUEST_VP',
  SET_REQUEST_VP: 'SET_REQUEST_VP',
  GET_RQUEST_USER_PROPERTY: 'GET_RQUEST_USER_PROPERTY',
  SET_RQUEST_USER_PROPERTY: 'SET_RQUEST_USER_PROPERTY',
};

export default inviteActionTypes;
